import { useEffect } from "react";

interface IUseResizeObserverProps {
    onResize: (entry: ResizeObserverEntry) => void;
    observingElement: HTMLElement | null | undefined;
}

export const useResizeObserver = ({ onResize, observingElement }: IUseResizeObserverProps) => {
    useEffect(() => {
        if (!observingElement) {
            return;
        }

        const observer = new ResizeObserver(([entry]) => {
            onResize(entry);
        });

        observer.observe(observingElement);

        return () => observer.disconnect();
    }, [observingElement, onResize]);
};
